// core
export const REDIRECT_CLICKED = 'Redirect Clicked';
// additional
export const WALLET_CONNECTED = 'Wallet Connected';
